module.exports = __webpack_public_path__ + "img/20191021163350462.541aa6d2.jpg";